import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (this.authService.isAuthenticated() && this.authService.isAdmin()) {
            return true;
        } else {
            this.router.navigate(['/dashboard']);
            return false;
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class UniversityGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Allow Admin, University, or Member role users
        const isUniversityOrMember = this.authService.isUniversity() || this.authService.isMember();
        if (this.authService.isAuthenticated() && (this.authService.isAdmin() || isUniversityOrMember)) {
            return true;
        } else {
            this.router.navigate(['/dashboard']);
            return false;
        }
    }
}

@Injectable({
    providedIn: 'root'
})
export class UniversityOnlyGuard implements CanActivate {
    constructor(
        private authService: AuthService,
        private router: Router
    ) { }

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Allow University or Member role users (but not Admins)
        const isUniversityOrMember = this.authService.isUniversity() || this.authService.isMember();
        if (this.authService.isAuthenticated() && isUniversityOrMember && !this.authService.isAdmin()) {
            return true;
        } else {
            this.router.navigate(['/dashboard']);
            return false;
        }
    }
}
